import { render, staticRenderFns } from "./StandardList.vue?vue&type=template&id=379b74ad&scoped=true&"
import script from "./StandardList.vue?vue&type=script&lang=js&"
export * from "./StandardList.vue?vue&type=script&lang=js&"
import style0 from "./StandardList.vue?vue&type=style&index=0&id=379b74ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379b74ad",
  null
  
)

export default component.exports